import { useField, useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  GridProps,
  Typography
} from '@material-ui/core';

const StyledGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export interface InlineMultiSelectOption {
  value: string;
  label: string;
}

export interface InlineMultiSelectProps {
  name: string;
  label: string;
  value?: string[];
  disabled?: boolean;
  options?: (InlineMultiSelectOption | string)[];
  helperText?: string;
  grid?: GridProps;
}

export const InlineMultiSelect: React.FC<InlineMultiSelectProps> = props => {
  let { label, name, disabled, options, helperText, grid, children } = props;
  const formik = useFormikContext();
  const [field, meta, { setValue, setTouched }] = useField(props);
  if (!grid) {
    // default field to expand entire width of form
    grid = { xs: 12 };
  }
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    console.log('handleChange', value);
    // field.onChange(event);
    let values = [...field.value];
    if (values.includes(value)) {
      values = values.filter(item => item !== value);
      setValue(values);
    } else {
      values.push(value);
      setValue(values);
    }
    // setTouched(true);
    formik.submitForm();
  };
  return useMemo(
    () => (
      <StyledGrid item className='inline-multi-select' {...grid}>
        <Typography variant='h5' gutterBottom>
          {label}
        </Typography>
        <FormControl
          error={meta.touched && Boolean(meta.error)}
          component='fieldset'
          {...field}
          name={name}
        >
          <FormGroup>
            {options &&
              options.map(option =>
                typeof option === 'string' ? (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        value={option}
                        color='primary'
                        disabled={disabled}
                        checked={field.value?.includes(option)}
                        onChange={event => handleChange(event, option)}
                      />
                    }
                    label={option}
                  />
                ) : (
                  <FormControlLabel
                    key={option.value}
                    control={
                      <Checkbox
                        value={option.value}
                        color='primary'
                        disabled={disabled}
                        checked={field.value?.includes(option.value)}
                        onChange={event => handleChange(event, option.value)}
                      />
                    }
                    label={option.label}
                  />
                )
              )}
            {children}
          </FormGroup>
          {meta.error ||
            (helperText && (
              <FormHelperText>{meta.error || helperText}</FormHelperText>
            ))}
        </FormControl>
      </StyledGrid>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [field.value, meta.error, label, options]
  );
};

export default InlineMultiSelect;
